import { useEffect } from 'react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
import { usePostHog } from '@posthog/react';
import { Home, ArrowLeft } from 'lucide-react';
import { SiteFooter } from '@/components/SiteFooter';

export function RootErrorBoundary() {
  const error = useRouteError();
  const posthog = usePostHog();

  useEffect(() => {
    if (!error) return;
    posthog?.captureException(error);
  }, [error, posthog]);

  const message = isRouteErrorResponse(error)
    ? error.statusText || `Erro ${error.status}`
    : error instanceof Error
      ? error.message
      : 'Ocorreu um erro inesperado.';

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <div className="flex-1 flex flex-col items-center justify-center text-center px-4">
        <div className="mb-8">
          <div className="text-8xl font-bold text-gray-300 mb-4">Erro</div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Algo deu errado</h1>
          <p className="text-gray-600 max-w-md">{message}</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-highlight text-gray-900 font-medium rounded-lg hover:bg-highlight/90 transition-colors"
          >
            <Home className="w-5 h-5" />
            Voltar ao Início
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Voltar
          </button>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
